import { ReactComponent as Logo } from '../images/catalogarius.svg';

const Footer = () => {
  return (
    <footer className="mt-auto w-full shrink-0 bg-white dark:bg-gray-800 shadow-sm border-t border-gray-200 dark:border-gray-700">
      <div className="w-full max-w-screen-xl mx-auto px-4 py-4 sm:px-4 sm:py-5">
        <div className="flex flex-col gap-4 items-stretch sm:flex-row sm:items-center sm:justify-between sm:gap-6">
          <a
            href="https://sigedon.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex self-start items-center gap-3 min-w-0 text-left sm:self-auto"
          >
            <Logo className="flex-shrink-0" width={40} height={40} />
            <span className="text-heading text-sm sm:text-base font-semibold text-gray-900 dark:text-white leading-snug">
              Catalogaris™ is a service provided by Sigedon LTD
            </span>
          </a>
          <ul className="flex w-full flex-col items-center gap-2 text-center text-sm font-medium text-body dark:text-white sm:w-auto sm:flex-row sm:flex-wrap sm:items-center sm:justify-end sm:gap-x-4 sm:gap-y-2 sm:text-left">
            <li>
              <a href="https://sigedon.com/terms-and-conditions" target="_blank" rel="noopener noreferrer" className="hover:underline">
                Terms of Service
              </a>
            </li>
            <li>
              <a href="https://sigedon.com/privacy-policy" target="_blank" rel="noopener noreferrer" className="hover:underline">
                Privacy Policy
              </a>
            </li>
            <li>
              <a href="https://sigedon.com/legal-notice" target="_blank" rel="noopener noreferrer" className="hover:underline">
                Legal Notice
              </a>
            </li>
            <li>
              <a href="https://sigedon.com/about-us" target="_blank" rel="noopener noreferrer" className="hover:underline">
                About Us
              </a>
            </li>
            <li>
              <a href="https://sigedon.com/contact-us" target="_blank" rel="noopener noreferrer" className="hover:underline">
                Contact Us
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
